// File#: _1_scroll-parallax
// Usage: theme-local scroll parallax utility
(function() {
  var scrollParallax = document.getElementsByClassName('js-scroll-parallax');
  if (!scrollParallax.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var ticking = false;

  function updateParallax() {
    ticking = false;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    for (var i = 0; i < scrollParallax.length; i++) {
      var element = scrollParallax[i];
      var media = element.getElementsByClassName('js-scroll-parallax__media')[0];
      if (!media) continue;

      var rect = element.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) continue;

      var speed = parseFloat(element.getAttribute('data-parallax-speed')) || 0.25;
      var offset = (viewportHeight / 2 - (rect.top + rect.height / 2)) * speed;
      media.style.transform = 'translate3d(0, ' + Math.round(offset) + 'px, 0)';
    }
  }

  function requestParallaxTick() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  }

  window.addEventListener('scroll', requestParallaxTick, { passive: true });
  window.addEventListener('resize', requestParallaxTick);
  window.addEventListener('load', requestParallaxTick);
  requestParallaxTick();
}());
